/* tslint:disable */
/* eslint-disable */
/**
 * People Rock Platform API
 * REST API for the People Rock Platform - An AI-powered competency development platform.  ## Features - User authentication and authorization (JWT) - Role-based access control (ADMIN, TRAINER, PARTICIPANT) - User management - Internationalization support (Portuguese, English) - Locale management  ## Authentication Most endpoints require JWT authentication. To authenticate: 1. Register a new account: POST /auth/register 2. Or login with existing credentials: POST /auth/login 3. Copy the JWT token from the response 4. Click \"Authorize\" button above and enter: Bearer {token} 5. All subsequent requests will include the authorization header  ## Localization The API supports Portuguese (default) and English. Set the Accept-Language header: - `Accept-Language: pt` for Portuguese - `Accept-Language: en` for English  ## Rate Limiting - `POST /api/auth/login`: 10 requests per minute per IP - `POST /api/auth/register`: 5 requests per hour per IP - Other endpoints are not rate limited by the API  ## Support For API support, contact the development team via the contact information below. 
 *
 * The version of the OpenAPI document: 1.0.0-SNAPSHOT
 * Contact: dev@peoplerock.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminCreateUserRequest } from '../models';
// @ts-ignore
import type { AdminUpdateUserRequest } from '../models';
// @ts-ignore
import type { PageUserResponse } from '../models';
// @ts-ignore
import type { Pageable } from '../models';
// @ts-ignore
import type { UpdateMyProfileRequest } from '../models';
// @ts-ignore
import type { UpdateUserCompanyAssociationRequest } from '../models';
// @ts-ignore
import type { UserCompanyAssociationHistoryResponse } from '../models';
// @ts-ignore
import type { UserResponse } from '../models';
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a user account with selected roles
         * @summary Create user (ADMIN)
         * @param {AdminCreateUserRequest} adminCreateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (adminCreateUserRequest: AdminCreateUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminCreateUserRequest' is not null or undefined
            assertParamExists('createUser', 'adminCreateUserRequest', adminCreateUserRequest)
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft-delete a user account
         * @summary Delete user (ADMIN)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUser', 'id', id)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve users with role-aware scope (ADMIN: all; TRAINER: participants and participants; COMPANY_ADMIN: own company\'s employees only), optionally filtered by company, search text, role, and active status.
         * @summary List users
         * @param {Pageable} pageable 
         * @param {number} [companyId] 
         * @param {string} [search] 
         * @param {string} [role] 
         * @param {boolean} [active] 
         * @param {string} [jobTitle] 
         * @param {string} [department] 
         * @param {number} [managerId] 
         * @param {string} [privacy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers: async (pageable: Pageable, companyId?: number, search?: string, role?: string, active?: boolean, jobTitle?: string, department?: string, managerId?: number, privacy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageable' is not null or undefined
            assertParamExists('getAllUsers', 'pageable', pageable)
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (jobTitle !== undefined) {
                localVarQueryParameter['jobTitle'] = jobTitle;
            }

            if (department !== undefined) {
                localVarQueryParameter['department'] = department;
            }

            if (managerId !== undefined) {
                localVarQueryParameter['managerId'] = managerId;
            }

            if (privacy !== undefined) {
                localVarQueryParameter['privacy'] = privacy;
            }

            if (pageable !== undefined) {
                for (const [key, value] of Object.entries(pageable)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all available role names
         * @summary List available roles (ADMIN)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableRoles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the authenticated user\'s profile information
         * @summary Get current user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a specific user\'s profile information
         * @summary Get user by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUserById', 'id', id)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve historical user-company associations
         * @summary Get user company history
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCompanyHistory: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUserCompanyHistory', 'id', id)
            const localVarPath = `/api/users/{id}/company-history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove my facilitator photo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMyPhoto: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/me/photo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a facilitator\'s photo (ADMIN)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserPhoto: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeUserPhoto', 'id', id)
            const localVarPath = `/api/users/{id}/photo`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the caller\'s own name, job title, department and language. The email and assessment or plan data are corrected through a RECTIFICATION request (POST /api/gdpr/requests).
         * @summary Correct my profile (GDPR Art. 16)
         * @param {UpdateMyProfileRequest} updateMyProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentUser: async (updateMyProfileRequest: UpdateMyProfileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateMyProfileRequest' is not null or undefined
            assertParamExists('updateCurrentUser', 'updateMyProfileRequest', updateMyProfileRequest)
            const localVarPath = `/api/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMyProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user profile, active state, roles and company
         * @summary Update user (ADMIN)
         * @param {number} id 
         * @param {AdminUpdateUserRequest} adminUpdateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (id: number, adminUpdateUserRequest: AdminUpdateUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUser', 'id', id)
            // verify required parameter 'adminUpdateUserRequest' is not null or undefined
            assertParamExists('updateUser', 'adminUpdateUserRequest', adminUpdateUserRequest)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Associate or unlink a user from a company
         * @summary Update user company association
         * @param {number} id 
         * @param {UpdateUserCompanyAssociationRequest} updateUserCompanyAssociationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserCompanyAssociation: async (id: number, updateUserCompanyAssociationRequest: UpdateUserCompanyAssociationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUserCompanyAssociation', 'id', id)
            // verify required parameter 'updateUserCompanyAssociationRequest' is not null or undefined
            assertParamExists('updateUserCompanyAssociation', 'updateUserCompanyAssociationRequest', updateUserCompanyAssociationRequest)
            const localVarPath = `/api/users/{id}/company`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserCompanyAssociationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * JPEG, PNG or WebP, up to 2 MB.
         * @summary Upload my facilitator photo
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMyPhoto: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadMyPhoto', 'file', file)
            const localVarPath = `/api/users/me/photo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * JPEG, PNG or WebP, up to 2 MB.
         * @summary Upload a facilitator\'s photo (ADMIN)
         * @param {number} id 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUserPhoto: async (id: number, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadUserPhoto', 'id', id)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadUserPhoto', 'file', file)
            const localVarPath = `/api/users/{id}/photo`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a user account with selected roles
         * @summary Create user (ADMIN)
         * @param {AdminCreateUserRequest} adminCreateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(adminCreateUserRequest: AdminCreateUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(adminCreateUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.createUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft-delete a user account
         * @summary Delete user (ADMIN)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.deleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve users with role-aware scope (ADMIN: all; TRAINER: participants and participants; COMPANY_ADMIN: own company\'s employees only), optionally filtered by company, search text, role, and active status.
         * @summary List users
         * @param {Pageable} pageable 
         * @param {number} [companyId] 
         * @param {string} [search] 
         * @param {string} [role] 
         * @param {boolean} [active] 
         * @param {string} [jobTitle] 
         * @param {string} [department] 
         * @param {number} [managerId] 
         * @param {string} [privacy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsers(pageable: Pageable, companyId?: number, search?: string, role?: string, active?: boolean, jobTitle?: string, department?: string, managerId?: number, privacy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUsers(pageable, companyId, search, role, active, jobTitle, department, managerId, privacy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getAllUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all available role names
         * @summary List available roles (ADMIN)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableRoles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableRoles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getAvailableRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the authenticated user\'s profile information
         * @summary Get current user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a specific user\'s profile information
         * @summary Get user by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve historical user-company associations
         * @summary Get user company history
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCompanyHistory(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserCompanyAssociationHistoryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCompanyHistory(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserCompanyHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove my facilitator photo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeMyPhoto(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeMyPhoto(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.removeMyPhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a facilitator\'s photo (ADMIN)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeUserPhoto(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeUserPhoto(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.removeUserPhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the caller\'s own name, job title, department and language. The email and assessment or plan data are corrected through a RECTIFICATION request (POST /api/gdpr/requests).
         * @summary Correct my profile (GDPR Art. 16)
         * @param {UpdateMyProfileRequest} updateMyProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCurrentUser(updateMyProfileRequest: UpdateMyProfileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCurrentUser(updateMyProfileRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.updateCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user profile, active state, roles and company
         * @summary Update user (ADMIN)
         * @param {number} id 
         * @param {AdminUpdateUserRequest} adminUpdateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(id: number, adminUpdateUserRequest: AdminUpdateUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(id, adminUpdateUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.updateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Associate or unlink a user from a company
         * @summary Update user company association
         * @param {number} id 
         * @param {UpdateUserCompanyAssociationRequest} updateUserCompanyAssociationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserCompanyAssociation(id: number, updateUserCompanyAssociationRequest: UpdateUserCompanyAssociationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserCompanyAssociation(id, updateUserCompanyAssociationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.updateUserCompanyAssociation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * JPEG, PNG or WebP, up to 2 MB.
         * @summary Upload my facilitator photo
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadMyPhoto(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadMyPhoto(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.uploadMyPhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * JPEG, PNG or WebP, up to 2 MB.
         * @summary Upload a facilitator\'s photo (ADMIN)
         * @param {number} id 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadUserPhoto(id: number, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadUserPhoto(id, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.uploadUserPhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * Create a user account with selected roles
         * @summary Create user (ADMIN)
         * @param {UsersApiCreateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(requestParameters: UsersApiCreateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.createUser(requestParameters.adminCreateUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft-delete a user account
         * @summary Delete user (ADMIN)
         * @param {UsersApiDeleteUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(requestParameters: UsersApiDeleteUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUser(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve users with role-aware scope (ADMIN: all; TRAINER: participants and participants; COMPANY_ADMIN: own company\'s employees only), optionally filtered by company, search text, role, and active status.
         * @summary List users
         * @param {UsersApiGetAllUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers(requestParameters: UsersApiGetAllUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageUserResponse> {
            return localVarFp.getAllUsers(requestParameters.pageable, requestParameters.companyId, requestParameters.search, requestParameters.role, requestParameters.active, requestParameters.jobTitle, requestParameters.department, requestParameters.managerId, requestParameters.privacy, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all available role names
         * @summary List available roles (ADMIN)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableRoles(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getAvailableRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the authenticated user\'s profile information
         * @summary Get current user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.getCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a specific user\'s profile information
         * @summary Get user by ID
         * @param {UsersApiGetUserByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(requestParameters: UsersApiGetUserByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.getUserById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve historical user-company associations
         * @summary Get user company history
         * @param {UsersApiGetUserCompanyHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCompanyHistory(requestParameters: UsersApiGetUserCompanyHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserCompanyAssociationHistoryResponse>> {
            return localVarFp.getUserCompanyHistory(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove my facilitator photo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMyPhoto(options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.removeMyPhoto(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a facilitator\'s photo (ADMIN)
         * @param {UsersApiRemoveUserPhotoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserPhoto(requestParameters: UsersApiRemoveUserPhotoRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.removeUserPhoto(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the caller\'s own name, job title, department and language. The email and assessment or plan data are corrected through a RECTIFICATION request (POST /api/gdpr/requests).
         * @summary Correct my profile (GDPR Art. 16)
         * @param {UsersApiUpdateCurrentUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentUser(requestParameters: UsersApiUpdateCurrentUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.updateCurrentUser(requestParameters.updateMyProfileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update user profile, active state, roles and company
         * @summary Update user (ADMIN)
         * @param {UsersApiUpdateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(requestParameters: UsersApiUpdateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.updateUser(requestParameters.id, requestParameters.adminUpdateUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Associate or unlink a user from a company
         * @summary Update user company association
         * @param {UsersApiUpdateUserCompanyAssociationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserCompanyAssociation(requestParameters: UsersApiUpdateUserCompanyAssociationRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.updateUserCompanyAssociation(requestParameters.id, requestParameters.updateUserCompanyAssociationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * JPEG, PNG or WebP, up to 2 MB.
         * @summary Upload my facilitator photo
         * @param {UsersApiUploadMyPhotoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMyPhoto(requestParameters: UsersApiUploadMyPhotoRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.uploadMyPhoto(requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * JPEG, PNG or WebP, up to 2 MB.
         * @summary Upload a facilitator\'s photo (ADMIN)
         * @param {UsersApiUploadUserPhotoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUserPhoto(requestParameters: UsersApiUploadUserPhotoRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.uploadUserPhoto(requestParameters.id, requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createUser operation in UsersApi.
 * @export
 * @interface UsersApiCreateUserRequest
 */
export interface UsersApiCreateUserRequest {
    /**
     * 
     * @type {AdminCreateUserRequest}
     * @memberof UsersApiCreateUser
     */
    readonly adminCreateUserRequest: AdminCreateUserRequest
}

/**
 * Request parameters for deleteUser operation in UsersApi.
 * @export
 * @interface UsersApiDeleteUserRequest
 */
export interface UsersApiDeleteUserRequest {
    /**
     * 
     * @type {number}
     * @memberof UsersApiDeleteUser
     */
    readonly id: number
}

/**
 * Request parameters for getAllUsers operation in UsersApi.
 * @export
 * @interface UsersApiGetAllUsersRequest
 */
export interface UsersApiGetAllUsersRequest {
    /**
     * 
     * @type {Pageable}
     * @memberof UsersApiGetAllUsers
     */
    readonly pageable: Pageable

    /**
     * 
     * @type {number}
     * @memberof UsersApiGetAllUsers
     */
    readonly companyId?: number

    /**
     * 
     * @type {string}
     * @memberof UsersApiGetAllUsers
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiGetAllUsers
     */
    readonly role?: string

    /**
     * 
     * @type {boolean}
     * @memberof UsersApiGetAllUsers
     */
    readonly active?: boolean

    /**
     * 
     * @type {string}
     * @memberof UsersApiGetAllUsers
     */
    readonly jobTitle?: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiGetAllUsers
     */
    readonly department?: string

    /**
     * 
     * @type {number}
     * @memberof UsersApiGetAllUsers
     */
    readonly managerId?: number

    /**
     * 
     * @type {string}
     * @memberof UsersApiGetAllUsers
     */
    readonly privacy?: string
}

/**
 * Request parameters for getUserById operation in UsersApi.
 * @export
 * @interface UsersApiGetUserByIdRequest
 */
export interface UsersApiGetUserByIdRequest {
    /**
     * 
     * @type {number}
     * @memberof UsersApiGetUserById
     */
    readonly id: number
}

/**
 * Request parameters for getUserCompanyHistory operation in UsersApi.
 * @export
 * @interface UsersApiGetUserCompanyHistoryRequest
 */
export interface UsersApiGetUserCompanyHistoryRequest {
    /**
     * 
     * @type {number}
     * @memberof UsersApiGetUserCompanyHistory
     */
    readonly id: number
}

/**
 * Request parameters for removeUserPhoto operation in UsersApi.
 * @export
 * @interface UsersApiRemoveUserPhotoRequest
 */
export interface UsersApiRemoveUserPhotoRequest {
    /**
     * 
     * @type {number}
     * @memberof UsersApiRemoveUserPhoto
     */
    readonly id: number
}

/**
 * Request parameters for updateCurrentUser operation in UsersApi.
 * @export
 * @interface UsersApiUpdateCurrentUserRequest
 */
export interface UsersApiUpdateCurrentUserRequest {
    /**
     * 
     * @type {UpdateMyProfileRequest}
     * @memberof UsersApiUpdateCurrentUser
     */
    readonly updateMyProfileRequest: UpdateMyProfileRequest
}

/**
 * Request parameters for updateUser operation in UsersApi.
 * @export
 * @interface UsersApiUpdateUserRequest
 */
export interface UsersApiUpdateUserRequest {
    /**
     * 
     * @type {number}
     * @memberof UsersApiUpdateUser
     */
    readonly id: number

    /**
     * 
     * @type {AdminUpdateUserRequest}
     * @memberof UsersApiUpdateUser
     */
    readonly adminUpdateUserRequest: AdminUpdateUserRequest
}

/**
 * Request parameters for updateUserCompanyAssociation operation in UsersApi.
 * @export
 * @interface UsersApiUpdateUserCompanyAssociationRequest
 */
export interface UsersApiUpdateUserCompanyAssociationRequest {
    /**
     * 
     * @type {number}
     * @memberof UsersApiUpdateUserCompanyAssociation
     */
    readonly id: number

    /**
     * 
     * @type {UpdateUserCompanyAssociationRequest}
     * @memberof UsersApiUpdateUserCompanyAssociation
     */
    readonly updateUserCompanyAssociationRequest: UpdateUserCompanyAssociationRequest
}

/**
 * Request parameters for uploadMyPhoto operation in UsersApi.
 * @export
 * @interface UsersApiUploadMyPhotoRequest
 */
export interface UsersApiUploadMyPhotoRequest {
    /**
     * 
     * @type {File}
     * @memberof UsersApiUploadMyPhoto
     */
    readonly file: File
}

/**
 * Request parameters for uploadUserPhoto operation in UsersApi.
 * @export
 * @interface UsersApiUploadUserPhotoRequest
 */
export interface UsersApiUploadUserPhotoRequest {
    /**
     * 
     * @type {number}
     * @memberof UsersApiUploadUserPhoto
     */
    readonly id: number

    /**
     * 
     * @type {File}
     * @memberof UsersApiUploadUserPhoto
     */
    readonly file: File
}

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * Create a user account with selected roles
     * @summary Create user (ADMIN)
     * @param {UsersApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public createUser(requestParameters: UsersApiCreateUserRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).createUser(requestParameters.adminCreateUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft-delete a user account
     * @summary Delete user (ADMIN)
     * @param {UsersApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public deleteUser(requestParameters: UsersApiDeleteUserRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).deleteUser(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve users with role-aware scope (ADMIN: all; TRAINER: participants and participants; COMPANY_ADMIN: own company\'s employees only), optionally filtered by company, search text, role, and active status.
     * @summary List users
     * @param {UsersApiGetAllUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getAllUsers(requestParameters: UsersApiGetAllUsersRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getAllUsers(requestParameters.pageable, requestParameters.companyId, requestParameters.search, requestParameters.role, requestParameters.active, requestParameters.jobTitle, requestParameters.department, requestParameters.managerId, requestParameters.privacy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all available role names
     * @summary List available roles (ADMIN)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getAvailableRoles(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getAvailableRoles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the authenticated user\'s profile information
     * @summary Get current user profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getCurrentUser(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a specific user\'s profile information
     * @summary Get user by ID
     * @param {UsersApiGetUserByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserById(requestParameters: UsersApiGetUserByIdRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve historical user-company associations
     * @summary Get user company history
     * @param {UsersApiGetUserCompanyHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserCompanyHistory(requestParameters: UsersApiGetUserCompanyHistoryRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserCompanyHistory(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove my facilitator photo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public removeMyPhoto(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).removeMyPhoto(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a facilitator\'s photo (ADMIN)
     * @param {UsersApiRemoveUserPhotoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public removeUserPhoto(requestParameters: UsersApiRemoveUserPhotoRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).removeUserPhoto(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the caller\'s own name, job title, department and language. The email and assessment or plan data are corrected through a RECTIFICATION request (POST /api/gdpr/requests).
     * @summary Correct my profile (GDPR Art. 16)
     * @param {UsersApiUpdateCurrentUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateCurrentUser(requestParameters: UsersApiUpdateCurrentUserRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateCurrentUser(requestParameters.updateMyProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user profile, active state, roles and company
     * @summary Update user (ADMIN)
     * @param {UsersApiUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUser(requestParameters: UsersApiUpdateUserRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUser(requestParameters.id, requestParameters.adminUpdateUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Associate or unlink a user from a company
     * @summary Update user company association
     * @param {UsersApiUpdateUserCompanyAssociationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUserCompanyAssociation(requestParameters: UsersApiUpdateUserCompanyAssociationRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUserCompanyAssociation(requestParameters.id, requestParameters.updateUserCompanyAssociationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * JPEG, PNG or WebP, up to 2 MB.
     * @summary Upload my facilitator photo
     * @param {UsersApiUploadMyPhotoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public uploadMyPhoto(requestParameters: UsersApiUploadMyPhotoRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).uploadMyPhoto(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * JPEG, PNG or WebP, up to 2 MB.
     * @summary Upload a facilitator\'s photo (ADMIN)
     * @param {UsersApiUploadUserPhotoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public uploadUserPhoto(requestParameters: UsersApiUploadUserPhotoRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).uploadUserPhoto(requestParameters.id, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}

